import React from "react";
import MessageTextBox from "./text-box";
import CommunityMessageList from "./list";
import CommunityChannel from "./channel";
import ExpandCollaps from "./expand-collaps";

const CommunityMessage = ({
  user,
  collaps,
  setCollaps,
  isMobile,
  goTo,
  community,
  channel,
}) => {
  return (
    <div
      className={isMobile ? `community_message mobile` : `community_message`}
    >
      {!isMobile && <ExpandCollaps setCollaps={setCollaps} collaps={collaps} />}
      <CommunityChannel
        isMobile={isMobile}
        community={community}
        channel={channel}
        goTo={goTo}
      />
      <CommunityMessageList
        user={user}
        isMobile={isMobile}
        community={community}
        channel={channel}
        goTo={goTo}
      />
      <MessageTextBox />
    </div>
  );
};
export default CommunityMessage;
